import React from 'react';

// ASSETS
import { getIcon } from './assets/index';

// INTERFACES
import { IIcon } from '../../interfaces/Icon.interface';

const Icon: React.FC<IIcon> = ({ type }: IIcon) => {
  const Component = getIcon(type);

  if (Component) {
    return <Component />;
  }

  return null;
};

export default Icon;
